module.exports = __webpack_public_path__ + "img/priority.4d479fca.svg";